import { useQuery, useMutation } from '../lib/query';
import { request, qs } from '../services/api';
import { listMessagingTokens, sendNotification, generateNotificationCopy } from '../services/messaging';

const KEY = 'messaging-tokens';
const USERS_KEY = 'users';

export const useMessagingTokens = (params) =>
  useQuery({ queryKey: [KEY, params], queryFn: () => listMessagingTokens(params) });

// All app users (for targeting a notification by user_id). Uses the /admin/users endpoint.
export const useUsers = (params) =>
  useQuery({ queryKey: [USERS_KEY, params], queryFn: () => request(`/users${qs(params)}`) });

export const useGenerateCopy = (opts = {}) =>
  useMutation({
    mutationFn: ({ prompt, tone }) => generateNotificationCopy({ prompt, tone }),
    onSuccess: opts.onSuccess,
    onError: opts.onError,
  });

export const useSendNotification = (opts = {}) =>
  useMutation({
    mutationFn: ({ payload, deviceToken }) => sendNotification(payload, { deviceToken }),
    onSuccess: opts.onSuccess,
    onError: opts.onError,
  });
